// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_3e2Ah","popoverWrapper":"_3e2Ah","root":"dVQ_s"};